import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ReplayProps = IconComponentBaseProps;

export const Replay = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: ReplayProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_7862_86162"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7862_86162)">
        <path
          d="M5.97461 10.7105C5.38486 10.7105 4.83232 10.599 4.31698 10.3759C3.80157 10.1528 3.35219 9.84962 2.96886 9.46628C2.58553 9.08295 2.28232 8.63357 2.05923 8.11816C1.83615 7.60282 1.72461 7.05028 1.72461 6.46053C1.72461 6.35412 1.76053 6.26503 1.83236 6.19328C1.90411 6.12145 1.99319 6.08553 2.09961 6.08553C2.20603 6.08553 2.29511 6.12145 2.36686 6.19328C2.43869 6.26503 2.47461 6.35412 2.47461 6.46053C2.47461 7.43553 2.81419 8.26262 3.49336 8.94178C4.17253 9.62095 4.99961 9.96053 5.97461 9.96053C6.94961 9.96053 7.77669 9.62095 8.45586 8.94178C9.13503 8.26262 9.47461 7.43553 9.47461 6.46053C9.47461 5.48553 9.13503 4.65845 8.45586 3.97928C7.77669 3.30012 6.94961 2.96053 5.97461 2.96053H5.84186L6.37273 3.49128C6.44707 3.5657 6.48373 3.65274 6.48273 3.75241C6.48182 3.85207 6.44515 3.94066 6.37273 4.01816C6.29515 4.09574 6.20603 4.13582 6.10536 4.13841C6.00478 4.14099 5.91569 4.10349 5.83811 4.02591L4.71411 2.89703C4.62369 2.8067 4.57848 2.70128 4.57848 2.58078C4.57848 2.4602 4.62369 2.35474 4.71411 2.26441L5.84773 1.13553C5.92207 1.0612 6.01036 1.02449 6.11261 1.02541C6.21486 1.02641 6.30478 1.0657 6.38236 1.14328C6.45478 1.22078 6.49228 1.30857 6.49486 1.40666C6.49736 1.50474 6.45986 1.59257 6.38236 1.67016L5.84186 2.21053H5.97461C6.56436 2.21053 7.1169 2.32207 7.63223 2.54516C8.14765 2.76824 8.59703 3.07145 8.98036 3.45478C9.36369 3.83812 9.6669 4.28749 9.88998 4.80291C10.1131 5.31824 10.2246 5.87078 10.2246 6.46053C10.2246 7.05028 10.1131 7.60282 9.88998 8.11816C9.6669 8.63357 9.36369 9.08295 8.98036 9.46628C8.59703 9.84962 8.14765 10.1528 7.63223 10.3759C7.1169 10.599 6.56436 10.7105 5.97461 10.7105Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
